/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from 'react';
import '../../../css/scoreboard-theme.css'
export default class GraphicScore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: ""
        };
    }
    componentDidMount() {
        // let url = "https://betfair.betstream.betgenius.com/betstream-view/page/betfair/" + this.props.eventType + "?eventId=" + parseInt(this.props.event_id) + "&culture=en-GB"
        // let url = BASE_IMAGE_PATH + "/score/index.html?matchId=" + String(27566336)
        // this.setState({ url: url })
        // if(!!this.props.score_id)
        const script = document.createElement("script");
        script.src = "https://widgets.sir.sportradar.com/352ac03e8c9e400b090348b6af1e0b91/widgetloader";
        script.async = true;
        document.body.appendChild(script);
        setTimeout(function tm(){
            if(document.getElementsByClassName("sr-poweredby__link").length > 0){
                document.getElementsByClassName("sr-poweredby__link")[0].style.display="none"
            }else{
                setTimeout(()=>{tm()},200)
            }
        },200)
     }
    render() {
        return (
            <>
                {!!this.props.score_id &&
                    <div id="sr-widget" className="sr-widget sr-widget-1" data-sr-widget="match.lmtPlus" data-sr-match-id={this.props.score_id} data-sr-layout="double" data-sr-collapse-to="momentum"  data-sr-momentum="extended"  ></div>
                }
            </>
        )
    }
}
